import request from '@/utils/request'

let LiveApi = {

    /*直播列表*/
    getList(data) {
        return request._post('/shop/plus.live.wx/index', data);
    },

	  /*直播列表同步*/
    syn(data) {
        return request._post('/shop/plus.live.wx/syn', data);
    },

    /*置顶设置*/
    settop(data) {
        return request._post('/shop/plus.live.wx/settop', data);
    },

    /*直播设置*/
    goLive(data) {
      return request._get('/shop/setting.LiveSet/index', data);
    },

    /*修改直播设置*/
    setLive(data) {
      return request._post('/shop/setting.LiveSet/index', data);
    },




}

export default LiveApi;



// WEBPACK FOOTER //
// ./src/api/live.js